import { memo } from "react";

import OwnerAnimalSelect from "../../components/multiforms/OwnerAnimalSelect";

const CreateAnimal = () => {
    return (
        <OwnerAnimalSelect type={"CreateAnimal"} />
    )
};

export default memo(CreateAnimal)